import { SEO } from "@/components/seo/SEO";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export default function AlgemeneVoorwaarden() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Algemene Voorwaarden - SOL-VI",
    "description": "Algemene voorwaarden van SOL-VI voor zonnepanelen, warmtepompen en duurzame energieoplossingen",
    "publisher": {
      "@type": "Organization",
      "name": "SOL-VI",
      "url": "https://sol-vi.nl"
    }
  };

  return (
    <>
      <SEO 
        title="Algemene Voorwaarden - SOL-VI | Voorwaarden Duurzame Energie"
        description="Algemene voorwaarden van SOL-VI voor zonnepanelen, warmtepompen en duurzame energieoplossingen in Gelderland."
        canonical="https://sol-vi.nl/algemene-voorwaarden"
        jsonLd={[structuredData]}
      />
      
      <Header />
      
      <main className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold mb-8">Algemene Voorwaarden</h1>
            
            <div className="prose prose-gray max-w-none">
              <p className="text-lg text-muted-foreground mb-8">
                Laatst bijgewerkt: 25 augustus 2024
              </p>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Artikel 1. Definities</h2>
                <p>In deze algemene voorwaarden wordt verstaan onder:</p>
                <ul className="list-disc list-inside space-y-2 mt-2">
                  <li><strong>SOL-VI:</strong> de besloten vennootschap SOL-VI, KVK 87825759</li>
                  <li><strong>Opdrachtgever:</strong> de natuurlijke of rechtspersoon die opdracht verstrekt</li>
                  <li><strong>Overeenkomst:</strong> de tussen partijen gesloten overeenkomst</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Artikel 2. Toepasselijkheid</h2>
                <p>
                  Deze algemene voorwaarden zijn van toepassing op alle aanbiedingen, offertes en overeenkomsten 
                  tussen SOL-VI en opdrachtgever, tenzij schriftelijk anders overeengekomen.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Artikel 3. Aanbiedingen en Offertes</h2>
                <ul className="list-disc list-inside space-y-2">
                  <li>Alle aanbiedingen en offertes zijn vrijblijvend</li>
                  <li>Offertes zijn 30 dagen geldig, tenzij anders vermeld</li>
                  <li>Prijzen zijn exclusief BTW en andere heffingen</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Artikel 4. Totstandkoming Overeenkomst</h2>
                <p>
                  Een overeenkomst komt tot stand door schriftelijke bevestiging van de opdracht door opdrachtgever 
                  of door aanvang van de werkzaamheden door SOL-VI.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Artikel 5. Uitvoering</h2>
                <ul className="list-disc list-inside space-y-2">
                  <li>SOL-VI voert de werkzaamheden naar beste kunnen uit</li>
                  <li>Planning is indicatief en afhankelijk van externe factoren</li>
                  <li>Opdrachtgever verschaft tijdig alle benodigde informatie</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Artikel 6. Betaling</h2>
                <ul className="list-disc list-inside space-y-2">
                  <li>Betaling geschiedt conform overeengekomen betalingsschema</li>
                  <li>Bij overschrijding betalingstermijn is 1% rente per maand verschuldigd</li>
                  <li>Alle incassokosten komen voor rekening van opdrachtgever</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Artikel 7. Garantie</h2>
                <p>
                  SOL-VI geeft garantie conform fabrieksgarantie op materialen en 2 jaar garantie op 
                  installatiewerkzaamheden, conform de algemeen geldende normen.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Artikel 8. Aansprakelijkheid</h2>
                <p>
                  De aansprakelijkheid van SOL-VI is beperkt tot het factuurbedrag. SOL-VI is niet aansprakelijk 
                  voor indirecte schade, tenzij er sprake is van opzet of grove schuld.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Artikel 9. Overmacht</h2>
                <p>
                  Bij overmacht is SOL-VI gerechtigd de uitvoering op te schorten of de overeenkomst te ontbinden 
                  zonder schadevergoeding.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold mb-4">Artikel 10. Geschillen</h2>
                <p>
                  Op alle overeenkomsten is Nederlands recht van toepassing. Geschillen worden voorgelegd aan 
                  de bevoegde rechter in het arrondissement waar SOL-VI is gevestigd.
                </p>
              </section>

              <div className="bg-muted p-6 rounded-lg mt-8">
                <h3 className="text-xl font-semibold mb-2">Contact</h3>
                <p>
                  Voor vragen over deze voorwaarden: <br />
                  SOL-VI <br />
                  E-mail: <a href="mailto:info@sol-vi.nl" className="text-primary hover:underline">info@sol-vi.nl</a> <br />
                  Telefoon: 06 17 10 57 86
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </>
  );
}